<template>
    <div class="relative">
        <div class="absolute top-5 left-1/2 -translate-x-1/2 z-20">
            <LoadingState
                v-if="loadingCourse"
                :loading="loadingCourse"
                :noBackground="false"
            />
        </div>
        <section
            v-for="section in course?.sections"
            :key="section.id || section.title"
        >
            <h5
                class="text-slate-800 dark:text-slate-100 text-sm font-medium mb-4 flex flex-col lg:flex-row justify-between px-3"
            >
                {{ section.title }}
                <span
                    class="text-slate-500 dark:text-slate-400 text-sm pt-3 lg:pt-0 whitespace-nowrap font-normal"
                >
                    {{ section.chapters.length }} lesson{{
                        section.chapters.length > 1 ? 's' : ''
                    }}
                </span>
            </h5>
            <ul class="mb-8">
                <ListItem
                    v-for="chapter in section.chapters"
                    :chapter="chapter"
                    :key="chapter"
                />
            </ul>
        </section>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useCoursesStore } from '@/store/courses';
import ListItem from '@/components/courses/chapter-list/list-item.vue';
import LoadingState from '@/components/ui/loading-state/loading-state.vue';

const store = useCoursesStore();
const { course, loadingCourse } = storeToRefs(store);
</script>
